import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import DealApi from "../api/DealApi";
import {
  EDITED_SUCCESS_MSG,
  ERROR_MSG,
} from "../../../../core/data/constants/constant";

const useUpdateDeal = () => {
  const queryClient = useQueryClient();

  const mutationUpdate = useMutation({
    mutationFn: ({ id, dealData }) => DealApi.updateDeal(id, dealData),
    onSuccess: () => {
      toast.success(EDITED_SUCCESS_MSG);
      queryClient.invalidateQueries("deals");
    },
    onError: (error) => {
      toast.error(error.response?.data?.msg || ERROR_MSG);
    },
  });

  return mutationUpdate;
};

export default useUpdateDeal;
